<div class="auth-flow-wrapper">
  <app-loading *ngIf="isLoading$ | async" [options]="loadingOpts$ | async"> </app-loading>

  <div class="auth-flow-container">
    <div class="auth-flow-title">Set New Password</div>

    <div class="auth-flow-subtext">You are required to enter a new password for your account.</div>

    <lib-reactive-form-group #form [bindTo]="req" (formSubmitted$)="formSubmitted(req)">
      <lib-reactive-form-password
        [inputName]="'password'"
        [required]="true"
        [creatingOrUpdatingPassword]="true"
        [confirmPassword]="true"
        [label]="'New Password'"
        [placeholder]="'Enter a new password.'"
        [bindingProperty]="'password'">
      </lib-reactive-form-password>

      <lib-reactive-form-password
        [inputName]="'confirmPassword'"
        [required]="true"
        [creatingOrUpdatingPassword]="true"
        [confirmPassword]="true"
        [label]="'Confirm Password'"
        [placeholder]="'Retype your new password.'"
        [bindingProperty]="'confirmPassword'">
      </lib-reactive-form-password>
    </lib-reactive-form-group>

    <div class="flex-container flex-space-between">
      <lib-button-primary [disabled]="form.disableSubmit$ | async" (buttonClicked)="form.submitForm()">
        Update Password
      </lib-button-primary>
      <lib-button-text (buttonClicked)="viewModel.clearUserAndGetBackToSignIn()"> Return to Sign In </lib-button-text>
    </div>
  </div>
</div>
